import NextFlock from './NextFlock';

export default NextFlock;
